import React, { useState } from 'react';
import { ChevronRight, User, Phone, Play, Calendar } from 'lucide-react';

const DetailPage = () => {
    const [activeTab, setActiveTab] = useState('firms');
  
    return (
      <div className="flex">
        <Sidebar />
        <MainContent activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    );
  };
  
  // Sidebar Komponenti
  const Sidebar = () => {
    const categories = [
      { name: 'AKARYAKIT – PETROL', count: 15 },
      { name: 'ARABA SATIŞ', count: 15 },
      { name: 'ASANSÖR', count: 15 },
      { name: 'AV MALZEMELERİ', count: 15 },
      { name: 'AVM', count: 15 },
      { name: 'AVUKAT', count: 0 },
      { name: 'BAHARAT – AKTAR', count: 0 },
      { name: 'BANKA – SİGORTA', count: 0 },
      { name: 'BEBEK – ÇOCUK', count: 0 },
      { name: 'BEYAZ EŞYA', count: 0 },
      { name: 'BİLGİSAYAR', count: 15 },
      { name: 'BÖCEK – HAŞERE İLAÇLAMA', count: 0 },
      { name: 'BOYA – SIVA – TADİLAT', count: 0 },
      { name: 'BRANDA TENTE ÇADIR', count: 0 },
      { name: 'CAFE BAR RESTORAN', count: 0 }
    ];
  
    return (
      <div className="w-80 bg-white shadow-lg p-4">
        <div className="bg-slate-700 text-white p-3 mb-4 rounded">
          <h3 className="font-bold flex items-center">
            <span className="mr-2">📋</span>
            KATEGORİLER
          </h3>
        </div>
        
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="flex items-center justify-between p-3 hover:bg-gray-100 rounded cursor-pointer transition"
            >
              <div className="flex items-center">
                <span className="mr-3 text-gray-400">
                  {category.count > 0 ? '🚗' : '📁'}
                </span>
                <span className="text-sm">{category.name}</span>
                <span className="text-xs text-gray-500 ml-2">({category.count})</span>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </div>
          ))}
        </div>
        
        <button className="w-full bg-amber-400 text-gray-800 py-3 mt-4 rounded font-bold hover:bg-amber-500 transition">
          Tümünü Gör ⬇
        </button>
      </div>
    );
  };
  
  // Ana İçerik Komponenti
  const MainContent = ({ activeTab, setActiveTab }) => {
    return (
      <div className="flex-1 p-6">
        {/* Görsel Slider */}
        <div className="relative bg-gray-800 h-64 rounded-lg overflow-hidden mb-6">
          <div className="absolute inset-0 flex items-center justify-center">
            <Play className="w-16 h-16 text-white opacity-80 cursor-pointer hover:opacity-100 transition" />
          </div>
          <div className="absolute bottom-4 left-4 bg-amber-400 px-4 py-2 rounded">
            <div className="flex items-center space-x-2">
              <Calendar className="w-4 h-4" />
              <span className="text-sm font-bold">25 Ekim 2016 19:50</span>
            </div>
          </div>
          <div className="absolute bottom-4 right-4">
            <button className="bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-600 transition">
              DEVAMINI GÖR
            </button>
          </div>
        </div>
  
        {/* Gold Üye Firmalar */}
        <div className="bg-amber-400 p-4 rounded-lg mb-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-bold flex items-center">
              <User className="w-5 h-5 mr-2" />
              GOLD ÜYE FİRMALAR
            </h2>
            <button className="bg-slate-700 text-white px-4 py-2 rounded text-sm hover:bg-slate-800 transition">
              TÜMÜNÜ GÖR →
            </button>
          </div>
  
          <div className="bg-white rounded-lg p-4">
            <div className="flex items-center space-x-4">
              <div className="w-32 h-32 bg-gray-300 rounded flex items-center justify-center">
                <span className="text-gray-500">Firma Logo</span>
              </div>
              <div className="flex-1">
                <div className="bg-amber-400 inline-block px-3 py-1 rounded text-sm font-bold mb-2">
                  Örnek Gold Firma
                </div>
                <div className="flex items-center space-x-2 text-sm text-gray-600">
                  <User className="w-4 h-4" />
                  <span>Örnek Yetkili</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-gray-600 mt-1">
                  <Phone className="w-4 h-4" />
                  <span>0555 555 55 55</span>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      
        {/* Alt İstatistikler */}
        <div className="flex justify-center space-x-8 mt-8">
          <StatCard icon="💼" value="15" label="FİRMA" color="amber" />
          <StatCard icon="📍" value="5" label="BÖLGE" color="amber" />
          <StatCard icon="📋" value="8" label="KATEGORİ" color="amber" />
          <StatCard icon="🎁" value="9" label="ÜRÜN" color="amber" />
          <StatCard icon="⭐" value="4" label="GOLD ÜYE" color="amber" />
        </div>
      </div>
    );
  };
  
  // İstatistik Kartı Komponenti
  const StatCard = ({ icon, value, label, color }) => {
    return (
      <div className="text-center">
        <div className="text-4xl mb-2">{icon}</div>
        <div className={`text-2xl font-bold text-${color}-500`}>{value}</div>
        <div className="text-sm text-gray-600">{label}</div>
      </div>
    );
  };

  export default DetailPage;